import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "AccountingAnalyticCategoryListPage" */
	'pages/Invoice/AccountingAnalyticCategory/AccountingAnalyticCategoryListPage'));

export default [{ component, exact: true, path: '/accounting_analytic_categories' }];